import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SbxElliotHeroSection from '../components/sections/SbxElliotHeroSection';
import NewsSection from '../components/sections/NewsSection';
import MentorSection from '../components/sections/MentorSection';
import FAQSection from '../components/sections/FAQSection';
import SecretsSection from '../components/sections/SecretsSection';
import TestimonialsSection from '../components/sections/TestimonialsSection';
import Footer from '../components/sections/Footer';
import MetaTags from '../components/common/MetaTags';
import { sendToN8nWebhook, prepareFormData, isWebhookConfigured } from '../config/webhooks';
import './LandingPage.css';

const SbxElliotPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nome: '',
    email: '',
    countryCode: '+55',
    whatsapp: ''
  });

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    
    // Validações básicas
    if (!formData.nome.trim()) {
      alert('Por favor, preencha seu nome.');
      return;
    }
    
    if (!formData.email.trim() || !formData.email.includes('@')) {
      alert('Por favor, preencha um email válido.');
      return;
    }
    
    if (!formData.whatsapp.trim()) {
      alert('Por favor, preencha seu WhatsApp.');
      return;
    }
    
    // Preparar dados para envio usando a função utilitária
    const submissionData = prepareFormData(formData, {
      ip_address: '', // Será preenchido pelo n8n se necessário
      form_version: '1.0',
      source: 'sbx-elliot-partnership'
    });
    
    // Log dos dados capturados
    console.log('📋 Dados capturados (SBX-Elliot):', submissionData);
    
    // Verificar se o webhook está configurado
    if (!isWebhookConfigured('SBX_ELLIOT_CAPTURE')) {
      console.warn('⚠️ Webhook do n8n não configurado. Dados salvos localmente.');
      // Salvar no localStorage como fallback
      localStorage.setItem('lead_sbx_elliot_' + Date.now(), JSON.stringify(submissionData));
    }
    
    // Envio para webhook do n8n específico do SBX Elliot
    try {
      await sendToN8nWebhook(submissionData, 'SBX_ELLIOT_CAPTURE');
      
      // Sucesso: limpar formulário e redirecionar com o nome da pessoa
      const nomeParaObrigado = formData.nome;
      setFormData({ nome: '', email: '', countryCode: '+55', whatsapp: '' });
      navigate('/obrigado', { state: { 
        nome: nomeParaObrigado,
        source: 'sbx-elliot'
      } });
      
    } catch (error) {
      console.error('❌ Erro ao enviar para o webhook do n8n:', error);
      
      // Fallback: salvar localmente e ainda redirecionar para não prejudicar UX
      localStorage.setItem('lead_sbx_elliot_fallback_' + Date.now(), JSON.stringify(submissionData));
      
      // Redirecionar para a página de obrigado com o nome da pessoa
      navigate('/obrigado', { state: { 
        nome: formData.nome,
        source: 'sbx-elliot'
      } });
      
      // Limpar formulário mesmo em caso de erro
      setFormData({ nome: '', email: '', countryCode: '+55', whatsapp: '' });
    }
  };

  // Função para formatar telefone brasileiro
  const formatPhoneBR = (value) => {
    // Remove tudo que não é dígito
    const numbers = value.replace(/\D/g, '');
    
    // Aplica a máscara baseada no tamanho
    if (numbers.length <= 2) {
      return `(${numbers}`;
    } else if (numbers.length <= 7) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2)}`;
    } else if (numbers.length <= 11) {
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7)}`;
    } else {
      // Limita a 11 dígitos
      return `(${numbers.slice(0, 2)}) ${numbers.slice(2, 7)}-${numbers.slice(7, 11)}`;
    }
  };

  const handleInputChange = (field, value) => {
    let processedValue = value;
    
    // Formatar telefone apenas para números brasileiros
    if (field === 'whatsapp' && formData.countryCode === '+55') {
      processedValue = formatPhoneBR(value);
    }
    
    setFormData(prev => ({
      ...prev,
      [field]: processedValue
    }));
  };

  return (
    <div className="landing-page">
      <MetaTags
        title="SBX + Elliot: A Parceria que vai Mudar sua Vida no Trade"
        description="Descubra como a parceria entre SBX Trade e Elliot pode te ajudar a conquistar sua liberdade financeira através do trade. Evento exclusivo!"
        keywords="SBX, Elliot, parceria, trade, trading, forex, bolsa de valores, day trade, viver de trade, educação financeira, investimentos"
        image="https://sbxtreinamentos.com.br/webinario/images/sbx-elliot-og-image.jpg"
        url="https://sbxtreinamentos.com.br/webinario/sbx-e-elliot"
        type="website"
        author="Eduardo SBX & Elliot"
        siteName="SBX Trade"
      />
      <main>
        <SbxElliotHeroSection 
          formData={formData}
          onInputChange={handleInputChange}
          onSubmit={handleFormSubmit}
        />
        <NewsSection />
        <MentorSection />
        <FAQSection />
        <SecretsSection />
        <TestimonialsSection />
      </main>
      <Footer />
    </div>
  );
};

export default SbxElliotPage;